import React, { useContext, useEffect, useRef, useState } from 'react'
import { HiTrendingUp, HiShoppingCart, HiOutlineExclamationCircle } from 'react-icons/hi'
import { IoCubeOutline } from 'react-icons/io5'
import { useLocation, useNavigate } from 'react-router-dom'
import { InventoryList } from '../components'
import InventoryCard from '../components/Inventory/Cards/InventoryCard'
import Pagination from '../components/Resources/Pagination/Pagination'
import { UserInfo } from '../contexts/allContext'
import { useRequest } from '../hooks/useRequest'
import classes from './product/read/PeroductListPage.module.css'

const Inventory = () => {
    const tableRef = useRef(null)
    const location = useLocation()
    const navigate = useNavigate()
    const { stateUser } = useContext(UserInfo)
    const { handleFetch } = useRequest()
    const userInfo = stateUser.info
    const itemsPerPage = 10
    const [filters, setFilters] = useState({
        all: true,
        showAll: true,
        sortBy: 'desc',
        retail: false,
        wholesale: false,
        active: true,
        variant: '',
        feature: '',
        lowStock: '',
        outOfStock: '',
    })

    const [search, setSearch] = useState({
        value: '',
        searchBy: 'sku',
        isSearchAble: false,
    })

    const [products, setProducts] = useState([])
    const [loading, setLoading] = useState(true)
    const [totalResults, setTotalResults] = useState(0)

    const queryParams = new URLSearchParams(location.search)
    const pageFromUrl = parseInt(queryParams.get('page')) || 1

    const [page, setPage] = useState(pageFromUrl - 1)

    const fetchProducts = async (currentPage) => {
        const { sortBy, variant, wholesale, retail, feature, active, lowStock, outOfStock, showAll } = filters
        const { value: searchValue, searchBy } = search
        const skip = currentPage * itemsPerPage
        setLoading(true)
        const params = {
            skip,
            limit: itemsPerPage,
            is_seller_active: true,
            is_product_active: active,
            sort_order_by: sortBy,
            ...(searchValue && { [searchBy]: searchValue }),
            ...(!showAll && { is_wholesale: wholesale }),
            ...(!showAll && { is_retail: retail }),
            // add new filters from here
            ...(variant !== '' && { is_variant: variant }),
            ...(feature !== '' && { is_feature: feature }),
            ...(lowStock !== '' && { is_stock_critical: lowStock }),
            ...(outOfStock !== '' && { is_stock_out: outOfStock }),
        }
        try {
            const { data, isSuccess } = await handleFetch('v2/inventories/', params)
            if (isSuccess) {
                setProducts(data)
                setTotalResults(data[0]?.results || 0)
            }
        } catch (err) {
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (userInfo?.id) {
            fetchProducts(page)
        }
    }, [userInfo?.id, page, filters])

    useEffect(() => {
        if (search.isSearchAble) {
            fetchProducts(page)
        }
    }, [search])

    //update url
    useEffect(() => {
        const newPageNumber = page + 1
        const newQueryParams = new URLSearchParams(location.search)
        newQueryParams.set('page', newPageNumber)
        navigate(`?${newQueryParams.toString()}`, { replace: true })
    }, [page, navigate, location.search])

    // make sure search product shows on first page ...
    useEffect(() => {
        if (filters?.search) {
            setPage(0)
        }
    }, [filters])

    const scrollToTable = () => {
        if (tableRef.current) {
            tableRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    return (
        <>
            {/* <div className={classes.cardWrapper}>
                <InventoryCard title={'Recent Products'} icons={<IoCubeOutline />} />
                <InventoryCard
                    title={'Low Stock Products'}
                    icons={<HiOutlineExclamationCircle />}
                    cardParams={'is_stock_critical'}
                    scrollToTable={scrollToTable}
                    setFilters={setFilters}
                    label={'lowStock'}
                />
                <InventoryCard
                    title={'Stock Out Products'}
                    icons={<IoCubeOutline />}
                    cardParams={'is_stock_out'}
                    scrollToTable={scrollToTable}
                    setFilters={setFilters}
                    label={'outOfStock'}
                />
            </div> */}
            <div className={classes.container} ref={tableRef}>
                <InventoryList
                    products={products}
                    filters={filters}
                    setFilters={setFilters}
                    setPage={setPage}
                    loading={loading}
                    search={search}
                    setSearch={setSearch}
                    page={page}
                    limit={itemsPerPage}
                />
                <Pagination
                    totalResults={totalResults}
                    itemsPerPage={itemsPerPage}
                    onPageChange={setPage}
                    currentPage={page}
                />
            </div>
        </>
    )
}

export default Inventory
